(function () {
  const SPEED_PX_PER_SEC = 45;
  const MIN_DURATION_SEC = 20;
  const SOURCE_COUNT_ATTR = 'data-banner-scroll-source-count';
  const MAX_CLONES = 40;
  let resizeTimer;

  function sourceChildren(track) {
    const total = track.children.length;
    if (!total) return [];

    if (!track.hasAttribute(SOURCE_COUNT_ATTR)) {
      track.setAttribute(SOURCE_COUNT_ATTR, String(total));
    }

    return Array.from(track.children).slice(0, Number(track.getAttribute(SOURCE_COUNT_ATTR)));
  }

  function fillTrack(track, minWidth) {
    const source = sourceChildren(track);
    if (!source.length || !minWidth) return;

    let guard = 0;
    while (track.scrollWidth < minWidth && guard < MAX_CLONES) {
      source.forEach((node) => track.appendChild(node.cloneNode(true)));
      guard += 1;
    }
  }

  function setBannerScrollDurations(root) {
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.banner-collection-scroll-title, .banner-collection-scroll-products').forEach((row) => {
      const tracks = row.querySelectorAll(':scope > .banner-collection-scroll');
      if (!tracks.length) return;

      const minWidth = row.clientWidth;
      tracks.forEach((track) => fillTrack(track, minWidth));

      const width = tracks[0].scrollWidth;
      if (!width) return;

      const duration = Math.max(MIN_DURATION_SEC, width / SPEED_PX_PER_SEC);
      row.style.setProperty('--banner-scroll-duration', `${duration}s`);
    });
  }

  function init(event) {
    const root = event && event.target && event.target.querySelectorAll ? event.target : document;
    setBannerScrollDurations(root);

    // Product thumbs can change track width after load
    root.querySelectorAll('.banner-collection-scroll-products img').forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', () => setBannerScrollDurations(root), { once: true });
    });
  }

  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => setBannerScrollDurations(document), 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', onResize);
})();
